"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GetSurveySearchServiceResponse", {
    enumerable: true,
    get: function() {
        return GetSurveySearchServiceResponse;
    }
});
const _models = require("@performyard/models");
const _base = require("../../base");
const GetSurveySearchServiceResponse = _base.GetBaseSearchServiceResponse.extend({
    results: _models.SurveyModel.array()
});
